import { Card, Form, Input, message, Modal, Select, Switch, Upload } from 'antd'
import _, { size } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux"
import CustomButton from '../../../components/CustomButton'
import { actionCreateExpert, actionGetExpertById } from '../../../redux/post/actions'
import btnX from '../../assets/images/btnX.png'
import { convertToSlug } from '../../lib/common'
import TextArea from 'antd/lib/input/TextArea'
import { useHistory, withRouter } from "react-router-dom";
import { CaretDownOutlined } from '@ant-design/icons'
import { uploadOneFile } from '../../../redux/upload/actions'
import { injectIntl } from 'react-intl'
import { useSubheader } from '../../../_metronic/layout'
const formRef = React.createRef()
function CreateUpdateExpert(props) {
    const [formData, setFormData] = useState({
        title: '', description: ''
    });
    const [degree2, setDegree2] = useState({
        title: '', description: ''
    });
    const [experience1, setExperience1] = useState({
        title: '', description: ''
    });
    const [experience2, setExperience2] = useState({
        title: '', description: ''
    });
    const dispatch = useDispatch()
    const suhbeader = useSubheader();
    const { intl, filterModal } = props
    suhbeader.setTitle(intl.formatMessage({ id: recordModal?.id !== undefined ? 'SIDEBAR.EXPERT.UPDATE' : 'SIDEBAR.EXPERT.CREATE' }));
    const [dataInput, setDataInput] = useState(null)
    const [status, setStatus] = useState(false)
    const [position, setPosition] = useState(null)
    const [gender, setGender] = useState()
    const [recordModal, setRecordModal] = useState(null)
    const history = useHistory();
    const [department, setDepartment] = useState()
    const [description, setDescrition] = useState(null)
    const [office, setOffice] = useState(null)
    const [fileUpload, setFileUpload] = useState(null)
    const [fileUploadAvatar, setFileUploadAvatar] = useState(null)
    const [oldFileUpload, setOldFileUpload] = useState('https://api.hanagold.vn/uploads/1641181437932-defaultImageDashed.png')
    const [oldFileUploadAvatar, setOldFileUploadAvatar] = useState('https://api.hanagold.vn/uploads/1641181437932-defaultImageDashed.png')

    const onBack = () => {
        history.push('/expert')
    }

    const onChangTitle = (e) => {
        setDataInput(e.target.value)
        formRef.current.setFieldsValue({
            name: convertToSlug(e.target.value)
        })
    }

    const onSwitch = (value) => {
        setStatus(value)
    }

    const onChangePosition = (e) => {
        setPosition(e.target.value)
    }
    // useEffect(() => {
    //     if (recordModal && recordModal.id) {
    //         const { fullname, gender, position, department, degree, experience, description, image, avatar, office } = recordModal

    //         formRef.current.setFieldsValue({
    //             fullname: fullname,
    //             gender,
    //             office: office ?? 'Công ty CP Vàng Bạc Đá Quý Runtogether',
    //             position: position ? position : '',
    //             department,
    //             portrait: image,
    //             avatar,
    //             degree_title_1: degree[0].title ? degree[0].title : '',
    //             degree_description_1: degree[0].description ? degree[0].description : '',
    //             degree_title_2: degree[1].title ? degree[1].title : '',
    //             degree_description_2: degree[1].description ? degree[1].description : '',
    //             experience_title_1: experience[0].title ? experience[0].title : '',
    //             experience_description_1: experience[0].description ? experience[0].description : '',
    //             experience_title_2: experience[1].title ? experience[1].title : '',
    //             experience_description_2: experience[1].description ? experience[1].description : '',
    //             description: description ? description : '',
    //         })
    //         setOldFileUpload(image)
    //         setOldFileUploadAvatar(avatar)
    //     }
    // }, [dispatch, recordModal])

    useEffect(()=>{
        asyncFunc()
        console.log(props.match.params.id, '=======================');
    }, [dispatch])

    const asyncFunc = async () => {
        if (props.match.params.id && props.match.params.id !== '0') {
            const data = await dispatch(actionGetExpertById({ id: props.match.params.id }));
            if (data) {
                setRecordModal(data);
                const {
                    fullname,
                    avatar,
                    department,
                    position,
                    degree,
                    experience,
                    gender,
                    office,
                    description,
                    image
                } = data
                formRef.current.setFieldsValue({
                    fullname: fullname || '',
                    gender,
                    description: description || '',
                    position: position || '',
                    department,
                    office,
                    degree_title_1: degree[0].title ? degree[0].title : '',
                    degree_description_1: degree[0].description ? degree[0].description : '',
                    degree_title_2: degree[1].title ? degree[1].title : '',
                    degree_description_2: degree[1].description ? degree[1].description : '',
                    experience_title_1: experience[0].title ? experience[0].title : '',
                    experience_description_1: experience[0].description ? experience[0].description : '',
                    experience_title_2: experience[1].title ? experience[1].title : '',
                    experience_description_2: experience[1].description ? experience[1].description : '',
                })
                setStatus(data?.status === 1 ? true : false)
                setOldFileUpload(image)
                setOldFileUploadAvatar(avatar)
            }
        }
    }

    console.log(recordModal?.image, '=========================');

    const onSubmitDelayed = _.debounce(() => onSubmit(), 100)
    const onSubmit = async () => {

        await formRef.current.validateFields();
        let image = ""
        if (fileUpload) {
            let newUploadFile = new FormData();
            newUploadFile.append('file', fileUpload);
            image = await dispatch(uploadOneFile(newUploadFile))
        }
        console.log(image, '========================');
        let imageAvatar = ""
        if (fileUploadAvatar) {
            let newUploadFile = new FormData();
            newUploadFile.append('file', fileUploadAvatar);
            imageAvatar = await dispatch(uploadOneFile(newUploadFile))
        }

        if ((!oldFileUpload || oldFileUpload === 'https://api.hanagold.vn/uploads/1641181437932-defaultImageDashed.png') && !fileUpload) return message.error("Mời bạn tải ảnh chân dung!")
            if ((!oldFileUploadAvatar || oldFileUploadAvatar === 'https://api.hanagold.vn/uploads/1641181437932-defaultImageDashed.png') && !fileUploadAvatar) return message.error("Mời bạn tải ảnh đại diện!")

        const data = await formRef.current.getFieldsValue()
    
        let dataPush = {
            id: recordModal?.id,
            fullname: dataInput ?? recordModal?.fullname,
            url: dataInput ? convertToSlug(dataInput) : recordModal?.url,
            gender: gender ?? recordModal.gender,
            status: status === true ? 1 : 0,
            description: description ?? recordModal?.description,
            degree : [
                {title : data?.degree_title_1,description : data?.degree_description_1},
                {title : data?.degree_title_2,description : data?.degree_description_2},
            ],
            image: image || oldFileUpload,
            avatar: imageAvatar || oldFileUploadAvatar,
            experience: [
                {title : data?.experience_title_1,description : data?.experience_description_1},
                {title : data?.experience_title_2,description : data?.experience_description_2},
            ],
            office: office ?? recordModal?.office,
            position: position ?? recordModal?.positiosn,
            department: department ?? recordModal?.department
        }

        let messageSuccess = "Thêm mới thành công"
        //Sửa

        if (recordModal && recordModal.id) {
            dataPush = {
                id: recordModal.id,
                ...dataPush
            }
   
            messageSuccess = "Cập nhật thành công"
        }
        const res = actionCreateExpert({
            dataPush,
            filterModal
        })

        await dispatch(res);
  
        if (res) {
            history.push('/expert')
            return message.success(messageSuccess)
        }
    }
    const enterKeyPressed = (event) => {
        if (event.keyCode === 13) {
            onSubmit()
        }
    }
    const uploadProps = {
        // multiple: true,
        accept: "image/png,image/jpeg,image/svg+xml",
        beforeUpload: (file, fileList) => {
            const jfifRegex = /\.jfif$/i;
            if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
                message.error(`${file.name} is not a image file`);
                setTimeout(() => {
                    message.destroy()
                }, 100);
                return;
            } else if (jfifRegex.test(file.name)) {
                message.error(`${file.name} has a .jfif extension and is not allowed`);
                setTimeout(() => {
                    message.destroy()
                }, 2000);
                return;
            } else {
                if (file.size > 10000000) {
                    message.error("File size > 1 MB!")
                    setTimeout(() => {
                        message.destroy()
                    }, 2000);
                    return;
                }
                file.newImg = URL.createObjectURL(file)
                setFileUpload(file)
            }
            return false;
        }
    };
    const uploadPropsAvatar = {
        // multiple: true,
        accept: "image/png,image/jpeg,image/svg+xml",
        beforeUpload: (file, fileList) => {
            const jfifRegex = /\.jfif$/i;
            if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
                message.error(`${file.name} is not a image file`);
                setTimeout(() => {
                    message.destroy()
                }, 100);
                return;
            } else if (jfifRegex.test(file.name)) {
                message.error(`${file.name} has a .jfif extension and is not allowed`);
                setTimeout(() => {
                    message.destroy()
                }, 2000);
                return;
            } else {
                if (file.size > 10000000) {
                    message.error("File size > 1 MB!")
                    setTimeout(() => {
                        message.destroy()
                    }, 2000);
                    return;
                }
                file.newImg = URL.createObjectURL(file)
                setFileUploadAvatar(file)
            }
            return false;
        }
    };
    return (
        <>
            <Card style={{ paddingTop: '10px' }} key={recordModal?.id + 'Card-recordModal'}>
                <Form ref={formRef}>
                    <div className="layout-form-header row">
                        <div className='col-sm-6 mb--16'>
                            <div className="customLabel">Tên chuyên gia {' '}
                                <span className="customRequired">*</span>
                            </div>
                            <Form.Item
                                name="fullname"
                                required={true}
                                rules={[{
                                    validator: (_, value) => {
                                        if (!value || value.trim() === '') {
                                            return Promise.reject('Vui lòng nhập tên chuyên gia')
                                        }
                                        return Promise.resolve()
                                    }
                                }]}
                            >
                                <Input
                                    onKeyDown={enterKeyPressed}
                                    className="customInput width100"
                                    placeholder="Nhập tên chuyên gia"
                                    onChange={(e) => onChangTitle(e)}
                                    value={dataInput || ""}
                                    
                                />
                            </Form.Item>
                        </div>
                        <div className='col-sm-6 mb--16'>
                            <div className="customLabel">Giới tính{' '}
                                <span className="customRequired">*</span>
                            </div>
                            <Form.Item
                                name="gender"
                                rules={[{
                                    validator: (_, value) => {
                                        if (!value || value === '') {
                                            return Promise.reject('Vui lòng chọn giới tính')
                                        }
                                        return Promise.resolve()
                                    }
                                }]}
                            >
                                <Select
                                    className="customSelect"
                                    suffixIcon={<CaretDownOutlined />}
                                    placeholder="Chọn giới tính"
                                    value={gender || ""}
                                    onChange={(e) => { setGender(e) }}
                                >
                                    <Select.Option value={1}>Nam</Select.Option>
                                    <Select.Option value={2}>Nữ</Select.Option>
                                </Select>
                            </Form.Item>
                        </div>
                        <div className='col-sm-6 mb--16'>
                            <div className="customLabel">Vị trí, chức vụ {' '}
                                <span className="customRequired">*</span>
                            </div>
                            <Form.Item
                                name="position"
                                required={true}
                                rules={[{
                                    validator: (_, value) => {
                                        if (!value || value.trim() === '') {
                                            return Promise.reject('Vui lòng nhập chức vụ')
                                        }
                                        return Promise.resolve()
                                    }
                                }]}
                            >
                                <Input
                                    maxLength={200}
                                    onKeyDown={enterKeyPressed}
                                    className="customInput width100"
                                    placeholder="Nhập chức vụ"
                                    onChange={(e) => onChangePosition(e)}
                                    value={position || ""}
                                    
                                />
                            </Form.Item>
                        </div>
                        <div className='col-sm-6 mb--16'>
                            <div className="customLabel">Ban ngành {' '}
                                <span className="customRequired">*</span>
                            </div>
                            <Form.Item
                                name="department"
                                required={true}
                                rules={[{
                                    validator: (_, value) => {
                                        if (!value || value === '') {
                                            return Promise.reject('Vui lòng chọn ban ngành')
                                        }
                                        return Promise.resolve()
                                    }
                                }]}
                            >
                                <Select
                                    className="customSelect"
                                    suffixIcon={<CaretDownOutlined />}
                                    placeholder="Chọn ban ngành"
                                    value={department || ""}
                                    onChange={(e) => { setDepartment(e) }}
                                    defaultValue={''}
                                >
                                    <Select.Option value={''}>Chọn ban ngành</Select.Option>
                                    <Select.Option value={1}>Nhân sự chủ chốt</Select.Option>
                                    <Select.Option value={2}>Ban kiểm soát</Select.Option>
                                    <Select.Option value={3}>Ban giám đốc</Select.Option>
                                    <Select.Option value={4}>Hội đồng quản trị</Select.Option>
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="col-sm-4 mb--16">
                            <div className="customLabel">
                                Ảnh chân dung (213*321px) {' '}
                                <span className="customRequired">*</span>
                            </div>
                            <div className="rowy-center add-user-avatar">
                                <Form.Item
                                    name="portrait"
                                    // required={true}
                                    // rules={[{
                                    //     validator: (_, value) => {
                                    //         if (!value || value === '') {
                                    //             return Promise.reject('Vui lòng tải ảnh chân dung')
                                    //         }
                                    //         return Promise.resolve()
                                    //     }
                                    // }]}
                                >
                                    <Upload {...uploadProps}>
                                        <img
                                            src={fileUpload?.newImg || oldFileUpload} alt=""
                                            className="rad--4"
                                            style={{ objectFit: 'cover', width: '150px', height: '150px' }}
                                        />
                                    </Upload>
                                </Form.Item>
                            </div>
                        </div>
                        <div className="col-sm-4 mb--16">
                            <div className="customLabel">
                                Ảnh đại diện (213*321px) {' '}
                                <span className="customRequired">*</span>
                            </div>
                            <div className="rowy-center add-user-avatar">
                                <Form.Item
                                    name="avatar"
                                    // required={true}
                                    // rules={[{
                                    //     validator: (_, value) => {
                                    //         if (!value || value === '') {
                                    //             return Promise.reject('Vui lòng tải ảnh đại diện')
                                    //         }
                                    //         return Promise.resolve()
                                    //     }
                                    // }]}
                                >
                                    <Upload {...uploadPropsAvatar}>
                                        <img
                                            src={fileUploadAvatar?.newImg || oldFileUploadAvatar} alt=""
                                            className="rad--4"
                                            style={{ objectFit: 'cover', width: '150px', height: '150px' }}
                                        />
                                    </Upload>
                                </Form.Item>
                            </div>
                        </div>
                        <div className="col-sm-4 mb--16">
                            <div className="customLabel">
                                Trạng thái{` `}
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <Form.Item
                                    name="status"
                                >
                                    <Switch checked={status} onChange={onSwitch} /> <span style={{ marginLeft: '10px', fontWeight: '600' }}>{status === true ? 'Hoạt động' : 'Không hoạt động'}</span>
                                </Form.Item>
                            </div>
                        </div>
                        <div className='col-sm-12 mb--16'>
                            <div className="customLabel">Bằng cấp</div>
                            <div className='degree'>
                                <a>1
                                <span className="customRequired">*</span>.</a>
                                <Form.Item
                                    name="degree_title_1"
                                    required={true}
                                    rules={[{
                                        validator: (_, value) => {
                                            if (!value || value.trim() === '') {
                                                return Promise.reject('Vui lòng nhập ít nhất một bằng cấp')
                                            }
                                            return Promise.resolve()
                                        }
                                    }]}
                                >
                                    <TextArea
                                        onKeyDown={enterKeyPressed}
                                        className="customInput degreeInput"
                                        placeholder="Nhập tiêu đề bằng cấp"
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            title: e.target.value
                                        })}
                                        value={formData.title || ""}
                                        
                                        autoSize
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="degree_description_1"
                                    required={true}
                                    rules={[{
                                        validator: (_, value) => {
                                            if (!value || value.trim() === '') {
                                                return Promise.reject('Vui lòng nhập ít nhất một bằng cấp')
                                            }
                                            return Promise.resolve()
                                        }
                                    }]}
                                >
                                    <TextArea
                                        onKeyDown={enterKeyPressed}
                                        className="customInput degreeInput"
                                        placeholder="Nhập mô tả bằng cấp"
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            description: e.target.value
                                        })}
                                        value={formData.description || ""}
                                        
                                        autoSize
                                    />
                                </Form.Item>
                            </div>
                            <div className='degree2'>
                                <a>2.</a>
                                <Form.Item
                                    name="degree_title_2"
                                    required={true}
                                >
                                    <TextArea
                                        onKeyDown={enterKeyPressed}
                                        className="customInput degreeInput"
                                        placeholder="Nhập tiêu đề bằng cấp"
                                        onChange={(e) => setDegree2({
                                            ...degree2,
                                            title: e.target.value
                                        })}
                                        value={degree2.title || ""}
                                        
                                        autoSize
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="degree_description_2"
                                    required={true}
                                >
                                    <TextArea
                                        onKeyDown={enterKeyPressed}
                                        className="customInput degreeInput"
                                        placeholder="Nhập mô tả bằng cấp"
                                        onChange={(e) => setDegree2({
                                            ...degree2,
                                            description: e.target.value
                                        })}
                                        value={degree2.description || ""}
                                        
                                        autoSize
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='col-sm-12 mb--16'>
                            <div className="customLabel">Kinh nghiệm</div>
                            <div className='degree'>
                                <a>1
                                <span className="customRequired">*</span>.</a>
                                <Form.Item
                                    name="experience_title_1"
                                    required={true}
                                    rules={[{
                                        validator: (_, value) => {
                                            if (!value || value.trim() === '') {
                                                return Promise.reject('Vui lòng nhập ít nhất một kinh nghiệm')
                                            }
                                            return Promise.resolve()
                                        }
                                    }]}
                                >
                                    <TextArea
                                        onKeyDown={enterKeyPressed}
                                        className="customInput degreeInput"
                                        placeholder="Nhập tiêu đề kinh nghiệm"
                                        onChange={(e) => setExperience1({
                                            ...experience1,
                                            title: e.target.value
                                        })}
                                        value={experience1.title || ""}
                                        
                                        autoSize
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="experience_description_1"
                                    required={true}
                                    rules={[{
                                        validator: (_, value) => {
                                            if (!value || value.trim() === '') {
                                                return Promise.reject('Vui lòng nhập ít nhất một kinh nghiệm')
                                            }
                                            return Promise.resolve()
                                        }
                                    }]}
                                >
                                    <TextArea
                                        onKeyDown={enterKeyPressed}
                                        className="customInput degreeInput"
                                        placeholder="Nhập mô tả kinh nghiệm"
                                        onChange={(e) => setExperience1({
                                            ...experience1,
                                            description: e.target.value
                                        })}
                                        value={experience1.description || ""}
                                        
                                        autoSize
                                    />
                                </Form.Item>
                            </div>
                            <div className='degree2'>
                                <a>2.</a>
                                <Form.Item
                                    name="experience_title_2"
                                    required={true}
                                >
                                    <TextArea
                                        onKeyDown={enterKeyPressed}
                                        className="customInput degreeInput"
                                        placeholder="Nhập tiêu đề kinh nghiệm"
                                        onChange={(e) => setExperience2({
                                            ...experience2,
                                            title: e.target.value
                                        })}
                                        value={experience2.title || ""}
                                        
                                        autoSize
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="experience_description_2"
                                    required={true}
                                >
                                    <TextArea
                                        onKeyDown={enterKeyPressed}
                                        className="customInput degreeInput"
                                        placeholder="Nhập mô tả kinh nghiệm"
                                        onChange={(e) => setExperience2({
                                            ...experience2,
                                            description: e.target.value
                                        })}
                                        value={experience2.description || ""}
                                        autoSize
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='col-sm-12 mb--16'>
                            <div className="customLabel">Nơi làm việc</div>
                            <Form.Item
                                name="office"
                            >
                                <TextArea
                                    onKeyDown={enterKeyPressed}
                                    className="customInput width100"
                                    placeholder="Nhập nơi làm việc của chuyên gia"
                                    onChange={(e) => setOffice(e.target.value)}
                                    value={office || ""}
                                    autoSize
                                />
                            </Form.Item>
                        </div>
                        <div className='col-sm-12 mb--16'>
                            <div className="customLabel">Thông tin chuyên gia</div>
                            <Form.Item
                                name="description"
                            >
                                <TextArea
                                    onKeyDown={enterKeyPressed}
                                    className="customInput width100"
                                    placeholder="Nhập thông tin chuyên gia"
                                    onChange={(e) => setDescrition(e.target.value)}
                                    value={description || ""}
                                    autoSize
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="ant-pro-footer-bar" >
                        <div className="ant-pro-footer-bar-left" />
                        <div className="ant-pro-footer-bar-right">
                            <button type="button" className="ant-btn mr--16" onClick={onBack} >
                                <span>Cancel</span>
                            </button>
                            <button type="button" className="ant-btn ant-btn-primary" onClick={onSubmit}>
                                <span>OK</span>
                            </button>
                        </div>
                    </div>
                </Form>
            </Card>
        </ >
    )
}
export default injectIntl(withRouter(CreateUpdateExpert));